module.exports = __webpack_public_path__ + "static/media/diktat-27.d48dac0b.mp3";